import classNames from 'classnames';
import type { HTMLAttributes, ReactNode } from 'react';

import styles from './themed-status-tag.module.css';

export type StatusTone = 'inProgress' | 'finished' | 'failed' | 'neutral';

interface ThemedStatusTagProps extends HTMLAttributes<HTMLSpanElement> {
  tone: StatusTone;
  children: ReactNode;
}

/**
 * Solid status pill used by the Report-Status and Delivery-Status grids in the
 * themed (non-legacy) appearance. Presentational only — callers decide when to
 * render it (gated on `isThemedAppearance`) and which `tone`/label to pass; the
 * legacy tag stays untouched. Colour/text-per-theme lives in the co-located CSS
 * module.
 */
export const ThemedStatusTag = ({
  tone,
  children,
  className,
  ...rest
}: ThemedStatusTagProps) => (
  <span className={classNames(styles.tag, styles[tone], className)} {...rest}>
    {children}
  </span>
);
